export const CREATE_JOB_YARN_RECEIVE = 'CREATE_JOB_YARN_RECEIVE';
export const GET_JOB_YARN_RECEIVE = 'GET_JOB_YARN_RECEIVE';
export const JOB_YARN_RECEIVE_REQUEST = 'JOB_YARN_RECEIVE_REQUEST';
export const JOB_YARN_RECEIVE_REQUEST_SUCCESS = 'JOB_YARN_RECEIVE_REQUEST_SUCCESS';
export const UPDATE_JOB_YARN_RECEIVE = 'UPDATE_JOB_YARN_RECEIVE';
export const DELETE_JOB_YARN_RECEIVE = 'DELETE_JOB_YARN_RECEIVE';
export const JOB_YARN_RECEIVE_REQUEST_FAILURE = 'JOB_YARN_RECEIVE_REQUEST_FAILURE';
export const GET_JOB_YARN_RECEIVES_PAGE = 'GET_JOB_YARN_RECEIVES_PAGE';
